import { render, staticRenderFns } from "./business_users.vue?vue&type=template&id=0a754496&"
import script from "./business_users.vue?vue&type=script&lang=js&"
export * from "./business_users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports